<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-input size="mini" placeholder="请输入客户名称/项目名称" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
            <el-option
              v-for="item in business_list"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>

          <el-date-picker
            size="mini"
            v-model="where_time"
            unlink-panels
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>

          <el-button size="mini" type="primary" @click="search">搜索</el-button>

          <div style="width: 30px;display: inline-block;"></div>


<!--          - -->
          <el-button size="mini" type="primary" @click="exportExcel">导出报表</el-button>
<!--          <el-button size="mini" type="primary" @click="importExcel">导入</el-button>-->
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column label="序号" align="center" fixed="left" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.contract_area !== '合计'" v-text="scope.$index + 1 + (pageData.page - 1) * pageData.pageSize"></span>
              </template>
            </el-table-column>
            <el-table-column prop="contract_area" label="区域" align="center" width="250"></el-table-column>
            <el-table-column prop="party_a" label="客户名称" align="center" ></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" ></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column label="应收金额" prop="receipt_amount" width="100" align="center"></el-table-column>
            <el-table-column prop="paid_amount" label="回款金额" align="center" width="200"></el-table-column>
            <el-table-column prop="contract_leader" label="负责人" align="center" width="100"></el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="sizes,prev,pager,next" :total="pageData.total*1" :page-sizes="[20, 50, 100, 200]"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";

export default {
  name:"ReceivedAccount",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      },
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      f_status:"4",
      where_time:""
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.where_time=[CommonHelp.date("YYYY-01"),CommonHelp.date("YYYY-MM")]
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      CommonHelp.get("ReceivedAccount/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      CommonHelp.get("ReceivedAccount/exportExcelList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    handleSizeChange(val){
      this.pageData.pageSize = val;
      this.getList();
    },

  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ReceivedAccount.vue